import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, List, LogOut, Upload, Camera, X, CheckCircle, Plus, Users, BarChart2, Building2, ArrowLeft } from 'lucide-react';
import '../demo-professional.css';

export default function DemoNuevaPublicacion() {
  const navigate = useNavigate();
  const [libretaCargada, setLibretaCargada] = useState(false);
  const [fotos, setFotos] = useState([]);
  const [enviado, setEnviado] = useState(false);
  const [activeTab, setActiveTab] = useState('datos'); // 'datos' o 'fotos-tasaciones'

  const [formData, setFormData] = useState({
    marca: '',
    modelo: '',
    version: '',
    año: '',
    motor: '',
    kilometraje: '',
    combustible: 'Nafta',
    transmision: 'Manual',
    puertas: '5',
    estado: 'Bueno',
    unicoDueño: false,
    descripcion: '',
    expectativaCliente: '',
    valoracionVendedor: '',
  });

  const handleLogout = () => {
    localStorage.removeItem('demo_authenticated');
    navigate('/propuesta/demo');
  };

  const handleCargarLibreta = () => {
    // Simular carga de libreta con datos de ejemplo
    setLibretaCargada(true);
    setFormData({
      ...formData,
      marca: 'Chevrolet',
      modelo: 'Onix',
      version: 'Premier',
      año: '2020',
      motor: '1.0 Turbo',
      kilometraje: '45000',
      combustible: 'Nafta',
      transmision: 'Automática',
      puertas: '5',
    });
  };

  const handleAgregarFotos = () => {
    // Simular carga de fotos
    if (fotos.length < 10) {
      const nuevasFotos = [...fotos];
      for (let i = fotos.length; i < Math.min(fotos.length + 3, 10); i++) {
        nuevasFotos.push({
          id: i,
          url: `https://images.unsplash.com/photo-${1619767886558 + i}-efdc259cde1a?w=200&h=150&fit=crop`
        });
      }
      setFotos(nuevasFotos);
    }
  };

  const handleEliminarFoto = (id) => {
    setFotos(fotos.filter(f => f.id !== id));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEnviado(true);
    setTimeout(() => {
      navigate('/propuesta/demo/publicaciones');
    }, 2000);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  if (enviado) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="text-green-600" size={40} />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            ¡Publicación creada!
          </h2>
          <p className="text-gray-600">Redirigiendo al listado...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="demo-header sticky top-0 z-10">
        <div className="px-4 sm:px-6 py-3.5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)' }}>
              <Building2 className="text-white" size={18} />
            </div>
            <div>
              <h1 className="text-base font-bold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>Sistema de Tasación</h1>
              <p className="text-xs" style={{ color: '#94a3b8' }}>Vladimir & Aerocar</p>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <button onClick={() => navigate('/propuesta')} className="flex items-center gap-1.5 px-3 py-2 text-sm rounded-lg transition hover:bg-white/5" style={{ color: '#94a3b8' }} data-testid="demo-back-to-propuesta" title="Volver a la propuesta">
              <ArrowLeft size={16} /><span className="hidden sm:inline">Propuesta</span>
            </button>
            <button onClick={handleLogout} className="flex items-center gap-2 px-3 py-2 text-sm rounded-lg" style={{ color: '#94a3b8' }}>
              <LogOut size={16} /><span className="hidden sm:inline">Salir</span>
            </button>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav style={{ background: 'white', borderBottom: '1px solid #e2e8f0' }}>
        <div className="px-4 sm:px-6 py-2 flex items-center gap-1 sm:gap-2 overflow-x-auto">
          {[
            { id: 'dashboard',    label: 'Dashboard',    icon: <LayoutDashboard size={15} />, path: '/propuesta/demo/dashboard' },
            { id: 'publicaciones', label: 'Publicaciones', icon: <List size={15} />, path: '/propuesta/demo/publicaciones' },
            { id: 'revendedores',  label: 'Revendedores',  icon: <Users size={15} />, path: '/propuesta/demo/revendedores' },
            { id: 'reportes',      label: 'Reportes',      icon: <BarChart2 size={15} />, path: '/propuesta/demo/reportes' },
          ].map(tab => (
            <button key={tab.id} onClick={() => navigate(tab.path)}
              className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-lg whitespace-nowrap text-gray-500 hover:text-gray-800 hover:bg-gray-50 transition">
              {tab.icon}<span>{tab.label}</span>
            </button>
          ))}
          <button
            className="flex items-center gap-1.5 px-4 py-2 text-sm font-semibold text-white rounded-lg ml-auto whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)' }}>
            <Plus size={15} /><span>Nueva</span>
          </button>
        </div>
      </nav>

      {/* Content */}
      <main className="px-4 sm:px-6 py-6 sm:py-8 max-w-4xl mx-auto">
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <div className="px-4 sm:px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-orange-50 to-orange-100">
            <h2 className="text-lg sm:text-xl font-bold text-gray-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Nueva Publicación de Tasación
            </h2>
            <p className="text-sm text-gray-600 mt-1">
              Completa los datos del vehículo para iniciar el proceso de tasación
            </p>
          </div>

          <form onSubmit={handleSubmit} className="p-4 sm:p-6">
            {/* Tabs Navigation */}
            <div className="flex gap-2 mb-6 border-b border-gray-200">
              <button
                type="button"
                onClick={() => setActiveTab('datos')}
                className={`px-4 py-3 text-sm font-medium border-b-2 transition ${
                  activeTab === 'datos'
                    ? 'border-orange-600 text-orange-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                1. Datos del Vehículo
              </button>
              <button
                type="button"
                onClick={() => setActiveTab('fotos-tasaciones')}
                className={`px-4 py-3 text-sm font-medium border-b-2 transition ${
                  activeTab === 'fotos-tasaciones'
                    ? 'border-orange-600 text-orange-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                2. Fotos y Tasaciones
              </button>
            </div>

            {/* Tab 1: Datos del Vehículo */}
            {activeTab === 'datos' && (
              <div className="space-y-6">
                {/* BOTÓN CARGAR LIBRETA - PRIMERO */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-dashed border-blue-300 rounded-xl p-6">
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-4">
                      <Camera className="text-blue-600" size={28} />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                      Cargar Libreta de Conducir
                    </h3>
                    <p className="text-sm text-gray-600 mb-4">
                      {libretaCargada 
                        ? '✓ Libreta cargada - Datos completados automáticamente' 
                        : 'Opcional: Sube una foto de la libreta para autocompletar los datos del vehículo'}
                    </p>
                    <button
                      type="button"
                      onClick={handleCargarLibreta}
                      disabled={libretaCargada}
                      className={`inline-flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition ${
                        libretaCargada
                          ? 'bg-green-100 text-green-700 cursor-not-allowed'
                          : 'bg-blue-600 text-white hover:bg-blue-700'
                      }`}
                    >
                      {libretaCargada ? (
                        <>
                          <CheckCircle size={18} />
                          <span>Libreta Cargada</span>
                        </>
                      ) : (
                        <>
                          <Upload size={18} />
                          <span>Cargar Libreta</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>

                {/* Datos del Vehículo */}
                <div className="space-y-4">
                  <h3 className="text-base font-bold text-gray-900 pb-2 border-b border-gray-200" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Información del Vehículo
                  </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Marca <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="marca"
                    value={formData.marca}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                    placeholder="Ej: Chevrolet"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Modelo <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="modelo"
                    value={formData.modelo}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                    placeholder="Ej: Onix"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Versión
                  </label>
                  <input
                    type="text"
                    name="version"
                    value={formData.version}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                    placeholder="Ej: Premier, LT"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Año <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    name="año"
                    value={formData.año}
                    onChange={handleChange}
                    required
                    min="1990"
                    max="2025"
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                    placeholder="2020"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Motor <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="motor"
                    value={formData.motor}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                    placeholder="Ej: 1.6, 2.0 TSI"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Kilometraje <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    name="kilometraje"
                    value={formData.kilometraje}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                    placeholder="45000"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Combustible <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="combustible"
                    value={formData.combustible}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                  >
                    <option value="Nafta">Nafta</option>
                    <option value="Diesel">Diesel</option>
                    <option value="Eléctrico">Eléctrico</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Transmisión <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="transmision"
                    value={formData.transmision}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                  >
                    <option value="Manual">Manual</option>
                    <option value="Automática">Automática</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Cantidad de Puertas <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="puertas"
                    value={formData.puertas}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                  >
                    <option value="2">2 puertas</option>
                    <option value="3">3 puertas</option>
                    <option value="4">4 puertas</option>
                    <option value="5">5 puertas</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Estado General <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="estado"
                    value={formData.estado}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                  >
                    <option value="Excelente">Excelente</option>
                    <option value="Bueno">Bueno</option>
                    <option value="Regular">Regular</option>
                  </select>
                </div>
              </div>

              <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg">
                <input
                  type="checkbox"
                  id="unicoDueño"
                  name="unicoDueño"
                  checked={formData.unicoDueño}
                  onChange={handleChange}
                  className="w-5 h-5 text-orange-600 border-gray-300 rounded focus:ring-orange-500"
                />
                <label htmlFor="unicoDueño" className="text-sm font-medium text-gray-700 cursor-pointer">
                  Único dueño (se mostrará en la publicación)
                </label>
              </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Observaciones / Descripción <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="descripcion"
                      value={formData.descripcion}
                      onChange={handleChange}
                      required
                      rows="4"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm resize-none"
                      placeholder="Describe el estado del vehículo, detalles importantes, etc."
                    />
                  </div>
                </div>

                {/* Botón Siguiente */}
                <div className="flex justify-end pt-4 border-t border-gray-200">
                  <button
                    type="button"
                    onClick={() => setActiveTab('fotos-tasaciones')}
                    className="px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-medium rounded-lg hover:from-orange-600 hover:to-orange-700 transition"
                  >
                    Siguiente: Fotos y Tasaciones →
                  </button>
                </div>
              </div>
            )}

            {/* Tab 2: Fotos y Tasaciones */}
            {activeTab === 'fotos-tasaciones' && (
              <div className="space-y-6">
                {/* Fotos del Vehículo */}
                <div className="space-y-4">
                  <h3 className="text-base font-bold text-gray-900 pb-2 border-b border-gray-200" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Fotos del Vehículo {fotos.length >= 10 ? '(Máximo alcanzado)' : `(${fotos.length}/10 mínimo)`}
                  </h3>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                {fotos.map((foto) => (
                  <div key={foto.id} className="relative group aspect-video bg-gray-100 rounded-lg overflow-hidden border-2 border-gray-200">
                    <img src={foto.url} alt={`Foto ${foto.id + 1}`} className="w-full h-full object-cover" />
                    <button
                      type="button"
                      onClick={() => handleEliminarFoto(foto.id)}
                      className="absolute top-1 right-1 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition"
                    >
                      <X size={14} />
                    </button>
                  </div>
                ))}
                
                {fotos.length < 10 && (
                  <button
                    type="button"
                    onClick={handleAgregarFotos}
                    className="aspect-video bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center hover:bg-gray-100 hover:border-gray-400 transition"
                  >
                    <Camera className="text-gray-400 mb-1" size={24} />
                    <span className="text-xs text-gray-500 font-medium">Agregar fotos</span>
                  </button>
                )}
              </div>

                  {fotos.length < 10 && (
                    <p className="text-sm text-amber-600">
                      ⚠ Se requieren al menos 10 fotos del vehículo
                    </p>
                  )}
                </div>

                {/* Tasaciones */}
                <div className="space-y-4">
                  <h3 className="text-base font-bold text-gray-900 pb-2 border-b border-gray-200" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Tasaciones Iniciales
                  </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Expectativa del Cliente (USD) <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    name="expectativaCliente"
                    value={formData.expectativaCliente}
                    onChange={handleChange}
                    required
                    min="0"
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                    placeholder="13000"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Valoración del Vendedor (USD) <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    name="valoracionVendedor"
                    value={formData.valoracionVendedor}
                    onChange={handleChange}
                    required
                    min="0"
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition text-sm"
                    placeholder="12800"
                  />
                    </div>
                  </div>
                </div>

                {/* Botones de Acción */}
                <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t border-gray-200">
                  <button
                    type="button"
                    onClick={() => setActiveTab('datos')}
                    className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition"
                  >
                    ← Volver a Datos
                  </button>
                  <button
                    type="button"
                    onClick={() => navigate('/propuesta/demo/dashboard')}
                    className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    disabled={fotos.length < 10}
                    className={`flex-1 px-6 py-3 font-medium rounded-lg transition ${
                      fotos.length < 10
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        : 'bg-gradient-to-r from-orange-500 to-orange-600 text-white hover:from-orange-600 hover:to-orange-700'
                    }`}
                  >
                    Publicar para Tasación
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </main>
    </div>
  );
}
